import React from 'react';
export default function Player() { 
  return (<div style={{ width: '100%', height: 480, background: '#000', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    Player (connect to API playlist)
    </div>
    ); }
